import { createSlice } from '@reduxjs/toolkit';

export const constantSlice = createSlice({
  name: 'constant',
  initialState: {
    products: [],
    countries: [],
    addons: [],
    carts: [],
    sms_whatsapp: [],
    sms_whatsapp_number: {},
    purchaseNewNo: [],
  },
  reducers: {
    setProducts: (state, action) => {
      state.products = action.payload;
    },
    setCountries: (state, action) => {
      state.countries = action.payload;
    },
    setAddons: (state, action) => {
      state.addons = action.payload;
    },
    setCarts: (state, action) => {
      state.carts = action.payload;
    },
    setSms_Whatsapp: (state, action) => {
      state.sms_whatsapp = action.payload;
    },
    reset: (state) => {
      state.sms_whatsapp = [];
    },
    setSms_Whatsapp_Number: (state, action) => {
      state.sms_whatsapp_number = action.payload;
    },
    setPurchaseNewNo: (state, action) => {
      state.purchaseNewNo = action.payload;
    },
  }
});

export const {
  setProducts,
  setCountries,
  setAddons,
  setCarts,
  setSms_Whatsapp,
  reset,
  setSms_Whatsapp_Number,
  setPurchaseNewNo
} = constantSlice.actions

export default constantSlice.reducer;